import React, { useState, useEffect } from "react";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { Row, Col } from "reactstrap";
import Switch from "react-switch";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  ApproveRequestExport,
  EMPTY_DATA,
  NewRequestExport,
  defaultPageSize,
} from "../../../config/constants";
import NoContentFound from "../../common/NoContentFound";
import { PaginationWrapper } from "../../common/commonPagination";
import { fetchSupplierRequestHistory } from "./Actions";
import Button from "../../layout/Button";
import LoaderCustom from "../../common/LoaderCustom";
import {
  handleDepartmentHeader,
  searchNocontentFilter,
  userDetails,
} from "../../../helper";
import DayTime from "../../common/DayTimeWrapper";
import { reactLocalStorage } from "reactjs-localstorage";
import { setSelectedRowForPagination } from "../../simulation/actions/Simulation";
import _ from "lodash";
import Toaster from "../../common/Toaster";
import {
  resetStatePagination,
  updateCurrentRowIndex,
  updateGlobalTake,
  updatePageNumber,
  updatePageSize,
} from "../../common/Pagination/paginationAction";
import WarningMessage from "../../common/WarningMessage";
import ReactExport from "react-export-excel";
import { APPROVE_REQUEST_EXPORT } from "../../../config/masterData";
import { fetchExportApproveHistory } from "../supplierNewRequestHistory/Actions";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const gridOptions = {};
const SupplierRequestHistoryListing = (props) => {
  const dispatch = useDispatch();
  const { permissionNewRequestHistory } = props;
  const EmpIdData = userDetails();
  const history = useHistory();
  const [pageSize, setPageSize] = useState({
    pageSize10: true,
    pageSize50: false,
    pageSize100: false,
  });
  const [pageNo, setPageNo] = useState(1);
  const [currentRowIndex, setCurrentRowIndex] = useState(0);
  const [loader, setloader] = useState(false);
  const [globalTake, setGlobalTake] = useState(defaultPageSize);
  const [requestFromDate, setRequestFromDate] = useState('');
  const [requestToDate, setRequestToDate] = useState('');
  const [state, setState] = useState({
    isOpen: false,
    isEditFlag: false,
    tableData: [],
    isBulkUpload: false,
    shown: false,
    costingHead: [],
    BOPCategory: [],
    plant: [],
    vendor: [],
    gridApi: null,
    gridColumnApi: null,
    rowData: null,
    sideBar: { toolPanels: ['columns'] },
    showData: false,
    showPopup: false,
    deletedId: '',
    isLoader: true,
    disableFilter: true,
    disableDownload: false,
    dateArray: [],
    inRangeDate: [],
    analyticsDrawer: false,
    selectedRowData: [],
    floatingFilterData: {
      SupplierRepositoryRequestNo: "",
      SupplierName: "",
      UserName: "",
      RequestDate: "",
      ActionDate: "",
      Action: "",
    },
    warningMessage: false,
    filterModel: {},
    // pageNo: 1,
    // pageNoNew: 1,
    totalRecordCount: 0,
    isFilterButtonClicked: false,
    // currentRowIndex: 0,
    // pageSize: { pageSize10: true, pageSize50: false, pageSize100: false },
    noData: false,
    dataCount: 0,
    attachment: false,
    viewAttachment: [],
    render: false,

  });
  const { newRequestHistoryExport } = useSelector(
    (state) => state?.NewRequestHistoryExport
  );
  const { selectedRowForPagination } = useSelector((state) => state.simulation);
  const { supplierRequestHistory } = useSelector(
    (state) => state?.SupplierRequestHistoryReducer
  );
  const currentListQty = (supplierRequestHistory?.Data?.page - 1) * globalTake;
  let serialNumber = currentListQty + 1; // Start numbering from 1
  const usersWithSerialNumbers = (supplierRequestHistory?.data?.Data || []).map(
    (user, index) => {
      const updatedSerialNumber = serialNumber + index;
      return {
        ...user,
        serialNumber: updatedSerialNumber,
      };
    }
  );
  const getUsers = async (
    currentPage,
    pageSize,
    sortOrder,
    fieldName,
    requestFromDate,
    requestToDate,
    floatingFilterData
  ) => {
    try {
      const userDetail = userDetails();

      // Set loader to true to indicate data fetching
      setloader(true);

      // Dispatch the action to fetch users
      await dispatch(fetchSupplierRequestHistory({
        current_page: currentPage,
        per_page: pageSize,
        EmployeeId: userDetail?.EmployeeId,
        sortOrder: sortOrder,
        sortField: fieldName,
        requestFromDate: requestFromDate,
        requestToDate: requestToDate,
        ...floatingFilterData,
      }, (response, error) => {
        // Reset loader to false after the data is fetched
        setloader(false);
        if (response) {
          let isReset = true;
          setTimeout(() => {
            for (const prop in state?.floatingFilterData) {
              if (state?.floatingFilterData[prop] !== "") {
                isReset = false;
              }
            }
            // Sets the filter model via the grid API
            isReset ? gridOptions?.api?.setFilterModel({}) : gridOptions?.api?.setFilterModel(state?.filterModel);
          }, 300);

          setTimeout(() => {
            setState((prevState) => ({
              ...prevState,
              warningMessage: false,
            }));
          }, 335);

          setTimeout(() => {
            setState((prevState) => ({
              ...prevState,
              isFilterButtonClicked: false,
            }));
          }, 600);
        } else if (error) {
          // Handle errors, e.g., display an error message

        }
      }));
    } catch (error) {
      // Handle any unexpected errors

      setloader(false);
    }
  };




  const getUsersExport = async (EmpId, requestToDate, requestFromDate, floatingFilterData) => {
    try {
      // Set loader to true to indicate data fetching

      // Dispatch the action to fetch users
      await dispatch(
        fetchExportApproveHistory({
          EmployeeId: EmpId,
          requestToDate: requestToDate,
          requestFromDate: requestFromDate,
          ...floatingFilterData,
        })
      );
      // Reset loader to false after the data is fetched
      // setloader(false);
    } catch (error) {
      // Handle errors, e.g., display an error message

      // Reset loader to false in case of an error
      // setloader(false);
    }
  };
  useEffect(() => {
    reactLocalStorage.setObject("selectedRow", {});
    if (!props.stopApiCallOnCancel) {
      return () => {
        dispatch(setSelectedRowForPagination([]));
        dispatch(resetStatePagination());

        reactLocalStorage.setObject("selectedRow", {});
      };
    }
  }, []);
  useEffect(() => {
    // Function to fetch data after a 3-second delay
    const fetchDataWithDelay = async () => {
      // Show loader
      setloader(true);

      // Simulate loading for 3 seconds
      await new Promise((resolve) => setTimeout(resolve, 3000));

      try {
        // Fetch data after the delay
        await getUsers(pageNo, globalTake, "ASC");
      } catch (error) {

      } finally {
        // Hide loader after fetching data or encountering an error
        setloader(false);
      }
    };

    // Call fetchDataWithDelay function
    fetchDataWithDelay();
    getUsersExport(EmpIdData?.EmployeeId);
  }, []);
  var filterParams = {
    date: "", inRangeInclusive: true, filterOptions: ['equals', 'inRange'],
    comparator: function (filterLocalDateAtMidnight, cellValue) {
      var dateAsString = cellValue != null ? DayTime(cellValue).format('DD/MM/YYYY') : '';
      var newDate = filterLocalDateAtMidnight != null ? DayTime(filterLocalDateAtMidnight).format('DD/MM/YYYY') : '';
      handleDate(newDate)// FOR COSTING BENCHMARK BOP REPORT
      let date = document.getElementsByClassName('ag-input-field-input')
      for (let i = 0; i < date.length; i++) {
        if (date[i].type == 'radio') {
          date[i].click()
        }
      }

      setDate(newDate)
      if (dateAsString == null) return -1;
      var dateParts = dateAsString.split('/');
      var cellDate = new Date(
        Number(dateParts[2]),
        Number(dateParts[1]) - 1,
        Number(dateParts[0])
      );
      if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
        return 0;
      }
      if (cellDate < filterLocalDateAtMidnight) {
        return -1;
      }
      if (cellDate > filterLocalDateAtMidnight) {
        return 1;
      }
    },

    browserDatePicker: true,
    minValidYear: 2000,

  };
  const handleDate = (newDate) => {
    let temp = state.inRangeDate
    temp.push(newDate)
    setState((prevState) => ({ ...prevState, inRangeDate: temp }))
    if (props?.benchMark) { props?.handleDate(state.inRangeDate) }
    setTimeout(() => {
      var y = document.getElementsByClassName('ag-radio-button-input');
      var radioBtn = y[0];
      radioBtn?.click()

    }, 300);
  }

  const setDate = (date) => {
    setState((prevState) => ({ ...prevState, floatingFilterData: { ...state.floatingFilterData, RequestDate: date, ActionDate: date, newDate: date } }))
  }
  const onRowSelect = (event) => {
    var selectedRows = state?.gridApi?.getSelectedRows();
    if (selectedRows === undefined || selectedRows === null) {   //CONDITION FOR FIRST RENDERING OF COMPONENT
      selectedRows = selectedRowForPagination
    } else if (selectedRowForPagination && selectedRowForPagination.length > 0) {   // CHECKING IF REDUCER HAS DATA

      let finalData = []
      if (event.node.isSelected() === false) {    // CHECKING IF CURRENT CHECKBOX IS UNSELECTED
        for (let i = 0; i < selectedRowForPagination.length; i++) {
          if (selectedRowForPagination[i].SupplierRepositoryRequestNo === event.data.SupplierRepositoryRequestNo) {     // REMOVING UNSELECTED CHECKBOX DATA FROM REDUCER
            continue;
          } finalData.push(selectedRowForPagination[i])
        }
      } else { finalData = selectedRowForPagination }
      selectedRows = [...selectedRows, ...finalData]
    }
    let uniqeArray = _.uniqBy(selectedRows, "SupplierRepositoryRequestNo")           //UNIQBY FUNCTION IS USED TO FIND THE UNIQUE ELEMENTS & DELETE DUPLICATE ENTRY
    dispatch(setSelectedRowForPagination(uniqeArray))
    const newDataCount = uniqeArray.length;

    setState((prevState) => ({ ...prevState, dataCount: newDataCount }))
    let finalArr = selectedRows
    let length = finalArr?.length
    let uniqueArray = _.uniqBy(finalArr, "SupplierRepositoryRequestNo")
    if (props.isSimulation) {
      props.apply(uniqueArray, length)
    }
    setState((prevState) => ({ ...prevState, selectedRowData: selectedRows }))
    if (props?.benchMark) {
      let uniqueArrayNew = _.uniqBy(uniqueArray, "SupplierRepositoryRequestNo");
      if (uniqueArrayNew.length > 1) {
        dispatch(setSelectedRowForPagination([]));
        state.gridApi.deselectAll();
        Toaster.warning("Please select multiple bop's with same category");
      }
    }
  }

  const resetState = () => {
    setPageNo(1)
    setState((prevState) => ({ ...prevState, noData: false, inRangeDate: [], isFilterButtonClicked: false }));
    state.gridApi.setQuickFilter(null)
    state.gridApi.deselectAll();
    gridOptions?.columnApi?.resetColumnState(null);
    gridOptions?.api?.setFilterModel(null);
    for (var prop in state.floatingFilterData) {
      state.floatingFilterData[prop] = "";
    }
    setState((prevState) => ({
      ...prevState, floatingFilterData: state.floatingFilterData, warningMessage: false,
      //  pageNo: 1, pageNoNew: 1, currentRowIndex: 0,
    }));
    dispatch(updateCurrentRowIndex(0));
    dispatch(updatePageNumber(1));
    setGlobalTake(10)
    getUsers(
      1, // currentPage
      10, // pageSize
      "ASC", // sortOrder
      null, // fieldName
      null, // requestFromDate
      null, // requestToDate
      state?.floatingFilterData // floatingFilterData
    )
    setPageSize({ pageSize10: true, pageSize50: false, pageSize100: false });
    // getDataList("", 0, "", "", 0, 10, true, state.floatingFilterData);
    dispatch(setSelectedRowForPagination([]));
    setState((prevState) => ({
      ...prevState,
      globalTake: 10,
      dataCount: 0,
      pageSize: { ...prevState.pageSize, pageSize10: true, pageSize50: false, pageSize100: false, },
    }));
    dispatch(updateGlobalTake(10));
    dispatch(updatePageSize({ pageSize10: true, pageSize50: false, pageSize100: false }));
    if (state?.gridApi) {
      state?.gridApi.deselectAll();
    }
    // if (searchRef.current) {
    //   searchRef.current.value = '';
    // }
  };
  const onPageSizeChanged = (newPageSize) => {
    const pageSizeValue = Number(newPageSize);

    if (![10, 50, 100].includes(pageSizeValue)) {
      return; // Don't proceed if the page size is not valid
    }

    // Always set the page number to 1
    const newPageNo = 1;

    // Make the API call with the new page size and updated page number
    getUsers(newPageNo, pageSizeValue, "ASC", null, null, null, state.floatingFilterData);

    // Update the state to reflect the new page size and page number
    setPageSize({
      pageSize10: pageSizeValue === 10,
      pageSize50: pageSizeValue === 50,
      pageSize100: pageSizeValue === 100,
    });

    setGlobalTake(pageSizeValue);

    // Update the grid's page size
    state?.gridApi.paginationSetPageSize(pageSizeValue);

    // Update the page number state
    setPageNo(newPageNo);
  };

  const onBtPrevious = () => {
    if (currentRowIndex >= 10) {
      const previousNo = Math.max(0, currentRowIndex - 10);
      setCurrentRowIndex(previousNo);
      setPageNo((prevPageNo) => Math.max(1, prevPageNo - 1));

      // Retrieve sorting information
      const sortModel = state?.gridApi.getSortModel();
      const sort = sortModel.length > 0 ? sortModel[0].sort : "ASC";
      const colId = sortModel.length > 0 ? sortModel[0].colId : null;
      getUsers(pageNo - 1, globalTake, "ASC", null, requestFromDate, requestToDate, state.floatingFilterData);

      // Call getUsersExport with EmployeeId and floating filter data
      getUsersExport(EmpIdData?.EmployeeId, requestToDate, requestFromDate, state.floatingFilterData);

      // Fetch data for the previous page with sorting information
    }
  };

  const onBtNext = () => {
    if (
      (pageSize.pageSize50 &&
        pageNo >= Math.ceil(supplierRequestHistory?.data?.TotalItems / 50)) ||
      (pageSize.pageSize100 &&
        pageNo >= Math.ceil(supplierRequestHistory?.data?.TotalItems / 100))
    ) {
      return false;
    }

    if (currentRowIndex < supplierRequestHistory?.data?.TotalItems - 10) {
      const nextNo = currentRowIndex + 10;
      setCurrentRowIndex(nextNo);
      setPageNo((prevPageNo) => prevPageNo + 1);

      // Retrieve sorting information
      const sortModel = state?.gridApi.getSortModel();
      const sort = sortModel.length > 0 ? sortModel[0].sort : "ASC";
      const colId = sortModel.length > 0 ? sortModel[0].colId : null;
      // getUsers(pageNo + 1, defaultPageSize, "ASC", null, null, null, state.floatingFilterData);
      getUsers(1, globalTake, "ASC", null, requestFromDate, requestToDate, state.floatingFilterData);

      // Call getUsersExport with EmployeeId and floating filter data
      getUsersExport(EmpIdData?.EmployeeId, requestToDate, requestFromDate, state.floatingFilterData);
      // Fetch data for the next page with sorting information
      // getUsers(pageNo + 1, globalTake, sort, colId);
    }
  };

  const onSearch = () => {
    // Extract date range from state.filterModel if it exists
    let requestFromDate = null;
    let requestToDate = null;

    if (state.filterModel?.RequestDate) {
      if (state.filterModel.RequestDate.dateTo) {
        requestFromDate = DayTime(state.filterModel.RequestDate.dateFrom).format('DD/MM/YYYY');
        requestToDate = DayTime(state.filterModel.RequestDate.dateTo).format('DD/MM/YYYY');
      }
    } else if (state.filterModel?.ActionDate) {
      if (state.filterModel.ActionDate.dateTo) {
        requestFromDate = DayTime(state.filterModel.ActionDate.dateFrom).format('DD/MM/YYYY');
        requestToDate = DayTime(state.filterModel.ActionDate.dateTo).format('DD/MM/YYYY');
      }
    }
    setRequestFromDate(requestFromDate);
    setRequestToDate(requestToDate);
    // Update the state and dispatch actions
    setState((prevState) => ({
      ...prevState,
      warningMessage: false,
      isFilterButtonClicked: true,
    }));
    setPageNo(1)
    setGlobalTake(10)
    dispatch(updateCurrentRowIndex(0));
    dispatch(updatePageNumber(1));
    // Call getUsers with date range and floating filter data
    getUsers(1, globalTake, "ASC", null, requestFromDate, requestToDate, state.floatingFilterData);

    // Call getUsersExport with EmployeeId and floating filter data
    getUsersExport(EmpIdData?.EmployeeId, requestToDate, requestFromDate, state.floatingFilterData);
  };
  const onSortChanged = (event) => {
    const sortModel = event.api.getSortModel();
    if (sortModel.length > 0) {
      const { colId, sort } = sortModel[0];
      const sortOrder = sort === "asc" ? "ASC" : "DESC";
      getUsers(pageNo, globalTake, sortOrder, colId);
    } else {
      // Handle the case where there is no sorting
      getUsers(pageNo, globalTake, "ASC", null);
    }
  };
  const isFirstColumn = (params) => {
    var displayedColumns = params.columnApi.getAllDisplayedColumns();
    var thisIsFirstColumn = displayedColumns[0] === params.column;

    if (props?.isMasterSummaryDrawer) {
      return false;
    } else {
      return thisIsFirstColumn;
    }
  };
  const defaultColDef = {
    resizable: true,
    filter: true,
    sortable: false,
    // headerCheckboxSelection:
    //   isSimulation || props?.benchMark ? isFirstColumn : false,
    headerCheckboxSelectionFilteredOnly: true,
    checkboxSelection: isFirstColumn,
  };
  const effectiveDateFormatter = (props) => {
    const cellValue = props?.valueFormatted
      ? props.valueFormatted
      : props?.value;
    return cellValue != null ? DayTime(cellValue).format("DD/MM/YYYY") : "";
  };
  const onGridReady = (params) => {
    params.api.sizeColumnsToFit();
    setState((prevState) => ({ ...prevState, gridApi: params.api, gridColumnApi: params.columnApi }))
    params.api.paginationGoToPage(0);
    const checkBoxInstance = document.querySelectorAll('.ag-input-field-input.ag-checkbox-input');
    checkBoxInstance.forEach((checkBox, index) => {
      const specificId = `SupplierRequest_List_Floating${index / 11}`;
      checkBox.id = specificId;
    })
    const floatingFilterInstances = document.querySelectorAll('.ag-input-field-input.ag-text-field-input');
    floatingFilterInstances.forEach((floatingFilter, index) => {
      const specificId = `SupplierRequest_List_Floating_List_Floating${index}`;
      floatingFilter.id = specificId;
    });
  };
  const onFloatingFilterChanged = (value) => {
    let originalValue;
    setTimeout(() => {
      if (usersWithSerialNumbers?.length !== 0) {
        setState((prevState) => ({ ...prevState, noData: searchNocontentFilter(value, state.noData), }));
      }
    }, 500);
    setState((prevState) => ({ ...prevState, disableFilter: false }));
    const model = gridOptions?.api?.getFilterModel();

    setState((prevState) => ({ ...prevState, filterModel: model }));
    if (!state.isFilterButtonClicked) {
      setState((prevState) => ({ ...prevState, warningMessage: true }));
    }

    if (
      value?.filterInstance?.appliedModel === null ||
      value?.filterInstance?.appliedModel?.filter === ""
    ) {
      let isFilterEmpty = true;

      if (model !== undefined && model !== null) {
        if (Object.keys(model).length > 0) {
          isFilterEmpty = false;

          for (var property in state.floatingFilterData) {
            if (property === value.column.colId) {
              state.floatingFilterData[property] = "";
            }
          }

          setState((prevState) => ({ ...prevState, floatingFilterData: state.floatingFilterData, }));
        }

        if (isFilterEmpty) {
          setState((prevState) => ({ ...prevState, warningMessage: false }));
          for (var prop in state.floatingFilterData) {
            state.floatingFilterData[prop] = "";
          }
          setState((prevState) => ({ ...prevState, floatingFilterData: state.floatingFilterData, }));
        }
      }
    } else {
      if (
        value.column.colId === "RequestDate" ||
        value.column.colId === "ActionDate"
      ) {
        return false;
      }
      setState((prevState) => ({ ...prevState, floatingFilterData: { ...prevState.floatingFilterData, [value.column.colId]: value.filterInstance.appliedModel.filter, }, }));
    }

    if (originalValue !== undefined) {
      setState((prevState) => ({
        ...prevState, floatingFilterData: { ...prevState.floatingFilterData, [value.column.colId]: originalValue, },
      }));
    }

  };

  const onBtExport = () => {
    let tempArr = [];

    //tempArr = gridApi && gridApi?.getSelectedRows()
    tempArr = selectedRowForPagination;
    tempArr =
      tempArr && tempArr.length > 0
        ? tempArr
        : newRequestHistoryExport?.data
          ? newRequestHistoryExport?.data
          : [];
    return returnExcelColumn(APPROVE_REQUEST_EXPORT, tempArr);
  };
  const returnExcelColumn = (data = [], TempData) => {
    return (
      <ExcelSheet data={TempData} name={ApproveRequestExport}>
        {data &&
          data.map((ele, index) => (
            <ExcelColumn
              key={index}
              label={
                ele.label === "Company Name"
                  ? `${handleDepartmentHeader()} Name`
                  : ele.label
              }
              value={ele.value}
              style={ele.style}
            />
          ))}
      </ExcelSheet>
    );
  };
  const buttonFormatter = (props) => {
    const handleView = () => {
      // Handle view action
      const requestId = props.data?.SupplierRepositoryRequestId;
      history.push(`view-new-request-history?id=${requestId}`);
    };
    return (
      <div>
        {permissionNewRequestHistory?.View &&
          <button
            title="View"
            className="View mr-2"
            type="button"
            onClick={handleView}
          >
            {/* View */}
          </button>}
      </div>
    );
  };

  const statusButtonFormatter = (cell, row, enumObject, rowIndex) => {
    return (
      <>
        <label htmlFor="normal-switch" className="normal-switch">
          <Switch
            // onChange={() => handleChange(cell, row, enumObject, rowIndex)}
            checked={cell}
            background="#ff6600"
            onColor="#4DC771"
            onHandleColor="#ffffff"
            id="normal-switch"
            height={24}
          />
          git statu
        </label>
      </>
    );
  };



  const frameworkComponents = {
    totalValueRenderer: buttonFormatter,
    statusButtonFormatter: statusButtonFormatter,
    effectiveDateFormatter: effectiveDateFormatter,
    // hyphenFormatter: hyphenFormatter,
    customNoRowsOverlay: NoContentFound,
    // valuesFloatingFilter: SingleDropdownFloationFilter,
  };
  /**
   * @method statusButtonFormatter
   * @description Renders buttons
   */
  return (
    <>
      {loader ? <LoaderCustom customClass="simulation-Loader" /> : <div className="content-page w-100">
        <Row className="ag-grid-react custom-pagination">
          <Col>
            <div
              className={`ag-grid-wrapper overlay-contain ${props?.isDataInMaster && !props?.noData
                ? "master-approval-overlay"
                : ""
                } ${(props?.usersWithSerialNumbers?.data &&
                  props?.usersWithSerialNumbers?.data?.data?.length <= 0) ||
                  props?.noData
                  ? "overlay-contain"
                  : ""
                }`}
            >
              <div
                className={`ag-theme-material ${props?.loading && "max-loader-height"
                  }`}
              >
                {props?.noData && (
                  <NoContentFound
                    title={EMPTY_DATA}
                    customClassName="no-content-found"
                  />
                )}
                <Row className={`filter-row-large`}>

                  <Col md="12" className="mb-3">
                    <Row className="d-flex justify-content-end bd-highlight w100">
                      <Col md="4" className="mb-2">
                        <h1>Approval History</h1>
                      </Col>
                      <Col md="8" className="mb-3">
                        <div className="d-flex justify-content-end bd-highlight w100">
                          {(props?.isMasterSummaryDrawer === undefined || props?.isMasterSummaryDrawer === false) && (
                            <>
                              <div className="warning-message d-flex align-items-center">
                                {state.warningMessage && !state.disableDownload && (
                                  <>
                                    <WarningMessage dClass="mr-3" message={'Please click on filter button to filter all data'} />
                                    <div className='right-hand-arrow mr-2'></div>
                                  </>
                                )}
                              </div>
                              <Button id="vendorNeedListing_filter" className={"mr5 Tour_List_Filter"} onClick={() => onSearch()} title={"Filtered data"} icon={"filter"} disabled={state.disableFilter} />
                              {permissionNewRequestHistory?.Add && (
                                <button
                                  type="button"
                                  className={"user-btn mr5 Tour_List_Add"}
                                  onClick={() => history.push("/supplier-need-form")}
                                  title="Add"
                                >
                                  <div className={"plus mr-0"}></div>
                                  {/* ADD */}
                                </button>
                              )}

                              {permissionNewRequestHistory?.Download &&
                                <ExcelFile
                                  filename={NewRequestExport}
                                  fileExtension={".xls"}
                                  element={
                                    <button
                                      title={`Download ${state?.dataCount === 0
                                        ? "All"
                                        : "(" + state?.dataCount + ")"
                                        }`}
                                      type="button"
                                      className={"user-btn mr5 Tour_List_Download"}
                                    >
                                      <div className="download mr-1"></div>
                                      {`${state?.dataCount === 0
                                        ? "All"
                                        : "(" + state?.dataCount + ")"
                                        }`}
                                    </button>
                                  }
                                >
                                  {onBtExport()}
                                </ExcelFile>}

                              <Button id={"vendorNeedListing_refresh"} className={"Tour_List_Reset mr5"} onClick={() => resetState()} title={"Reset Grid"} icon={"refresh"} />
                              <button
                                type="button"
                                className={"apply "}
                                onClick={() => window.history.back()}
                              >
                                <div className={"back-icon"}></div>Back
                              </button>
                            </>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <AgGridReact
                  style={{ height: "100%", width: "100%" }}
                  defaultColDef={defaultColDef}
                  floatingFilter={true}
                  domLayout="autoHeight"
                  rowData={usersWithSerialNumbers}
                  onRowSelected={onRowSelect}
                  onFilterModified={onFloatingFilterChanged}
                  pagination={false}
                  paginationPageSize={globalTake}
                  onGridReady={onGridReady}
                  gridOptions={gridOptions}
                  noRowsOverlayComponent={"customNoRowsOverlay"}
                  onSortChanged={onSortChanged}
                  rowSelection={"multiple"}
                  noRowsOverlayComponentParams={{
                    title: EMPTY_DATA,
                    imagClass: "imagClass",
                  }}
                  frameworkComponents={frameworkComponents}
                  enableBrowserTooltips={true}
                >
                  <AgGridColumn
                    cellClass="has-checkbox"
                    field="SupplierRepositoryRequestNo"
                    headerName="Request No."
                  ></AgGridColumn>
                  <AgGridColumn
                    field="SupplierName"
                    floatingFilter={true}
                    headerName="Supplier Name"
                    sortable={true}
                    unSortIcon={true}
                    comparator={(valueA, valueB, nodeA, nodeB, isInverted) =>
                      valueA.toLowerCase().localeCompare(valueB.toLowerCase())
                    }
                  ></AgGridColumn>
                  <AgGridColumn
                    field="UserName"
                    floatingFilter={true}
                    headerName="Approver"
                    sortable={true}
                    unSortIcon={true}
                    comparator={(valueA, valueB, nodeA, nodeB, isInverted) =>
                      valueA.toLowerCase().localeCompare(valueB.toLowerCase())
                    }
                  ></AgGridColumn>
                  <AgGridColumn
                    field="RequestDate"
                    headerName="Request Date"
                    filter="agDateColumnFilter"
                    cellRenderer={"effectiveDateFormatter"}
                    filterParams={filterParams}
                    noRowsOverlay={
                      '<span className="ag-overlay-loading-center">No Data Found</span>'
                    }
                  ></AgGridColumn>
                  <AgGridColumn
                    // cellClass="has-checkbox"
                    field="ActionDate"
                    headerName="Action Date"
                    filter="agDateColumnFilter"
                    cellRenderer={"effectiveDateFormatter"}
                    filterParams={filterParams}
                  ></AgGridColumn>
                  <AgGridColumn

                    field="Action"
                    floatingFilter={true}
                    headerName="Status"
                    sortable={true}
                    unSortIcon={true}
                    comparator={(valueA, valueB, nodeA, nodeB, isInverted) =>
                      valueA.toLowerCase().localeCompare(valueB.toLowerCase())
                    }
                  ></AgGridColumn>

                  <AgGridColumn
                    headerName="Action"
                    cellRenderer={"totalValueRenderer"}
                    type="rightAligned"
                    floatingFilter={false}
                  ></AgGridColumn>
                </AgGridReact>
                <div className="button-wrapper">
                  {
                    <PaginationWrapper
                      gridApi={state?.gridApi}
                      setPage={onPageSizeChanged}
                      globalTake={globalTake}
                    />
                  }
                  {(props?.isMasterSummaryDrawer === undefined ||
                    props?.isMasterSummaryDrawer === false) && (
                      <div className="d-flex pagination-button-container">
                        <p>
                          <Button
                            id="rmDomesticListing_previous"
                            variant="previous-btn"
                            onClick={() => onBtPrevious()}
                          />
                        </p>
                        {pageSize.pageSize10 && (
                          <p className="next-page-pg custom-left-arrow">
                            Page <span className="text-primary">{pageNo}</span> of{" "}
                            {Math.ceil(
                              supplierRequestHistory?.data?.TotalItems / 10
                            )}
                          </p>
                        )}
                        {pageSize.pageSize50 && (
                          <p className="next-page-pg custom-left-arrow">
                            Page <span className="text-primary">{pageNo}</span> of{" "}
                            {Math.ceil(
                              supplierRequestHistory?.data?.TotalItems / 50
                            )}
                          </p>
                        )}
                        {pageSize.pageSize100 && (
                          <p className="next-page-pg custom-left-arrow">
                            Page <span className="text-primary">{pageNo}</span> of{" "}
                            {Math.ceil(
                              supplierRequestHistory?.data?.TotalItems / 100
                            )}
                          </p>
                        )}
                        <p>
                          <Button
                            id="rmDomesticListing_next"
                            variant="next-btn"
                            onClick={() => onBtNext()}
                          />
                        </p>
                      </div>
                    )}
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>}

    </>
  );
};
export default SupplierRequestHistoryListing;
